module.exports = __webpack_public_path__ + "img/noData.0f859ff7.png";